import http from './httpService'
import {getPagination} from "../utils/Utils";

export const API_ENDPOINTS = {

    AUTH_LOGIN : 'auth/login',
    AUTH_ME : 'auth/me',
    AUTH_CHANGE_PASS : 'auth/password/change',

    CATEGORIES : 'categories',
    MASTERS : 'masters',
    REGIONS: 'regions',
    SERVICES : 'services',
    COMPANIES: 'carservices',
    COMPANIES_COUNT: 'carservices/count',
    COMPANIES_IMPORT: 'carservices/import',
    COMPANIES_IMPORT_TEMPLATE: 'carservices/import/template',
    COMPANY_REQUESTS: 'carservices/requests',
    COMPANY_REQUESTS_COUNT: 'carservices/requests/count',
    COMPANY_APPROVE: 'carservices/approve',
    COMPANY_REJECT: 'carservices/reject',
    MASTER_REQUESTS: 'masters/requests',
    MASTER_REQUESTS_COUNT: 'masters/requests/count',
    MASTER_APPROVE: 'masters/approve',
    MASTER_REJECT: 'masters/reject',
    BOT_STATS: 'stats/buttons',
    WEBAPP_STATS: 'stats/webapp',
    USERS: 'users',
    USERS_COUNT: 'users/count',
    ACTIVE_USERS_COUNT: 'users/active/count',
    BLOCKED_USERS_COUNT: 'users/blocked/count',
    SOS: 'sos',
    AUTO_PART: 'autopart',
    REVIEW: 'review',
    REVIEW_COUNT: 'review/count',
    REVIEW_SEEN: 'review/seen',
    ADS: 'ads',
    ADS_DELETE: 'ads/delete',
    SOS_DELETE: 'sos/delete',
    AUTO_PART_DELETE: 'autopart/delete',

    SEND: 'send',

    ADD: 'create',
    UPDATE: 'update',
    DELETE: 'delete',
    DELETE_MASTER: 'master/delete',
    UPDATE_MASTER: 'master/update',
    ADD_REGION: 'region/create',
    UPDATE_REGION: 'region/update',
    WAREHOUSE_ACCOUNTS: 'warehouse/accounts',
    WAREHOUSE_ACCOUNTS_COUNT: 'warehouse/accounts/count',
    WAREHOUSE_CATALOG: 'warehouse/catalog',
    WAREHOUSE_SECTIONS: 'warehouse/sections',
    WAREHOUSE_APPROVE: 'warehouse/approve',
    WAREHOUSE_REJECT: 'warehouse/reject',
    WAREHOUSE_COMPANIES: 'warehouse/companies',
    SETTINGS: 'settings',
    UPDATE_SETTINGS: 'settings/update',
    ADD_CATEGORY: 'category/create',
    UPDATE_CATEGORY: 'category/update',
    ADD_MASTER: 'master/create',
    ADD_SERVICE: 'service/create',
    UPDATE_SERVICE: 'service/update',

    UPLOAD_IMAGE: 'upload/image',

}

export const authAPI = {
    me: (params) => http.get(API_ENDPOINTS.AUTH_ME, params),
    login: (params) => http.post(API_ENDPOINTS.AUTH_LOGIN, params),
    logout: (params) => http.delete(API_ENDPOINTS.AUTH_LOGIN, params),
    changePassword: (params) => http.post(API_ENDPOINTS.AUTH_CHANGE_PASS, params)
}


// A cleared antd column filter arrives as null/undefined — never put that in
// the query string, the API would try to cast "null" to an ObjectId.
const catsParam = (cats) =>
    Array.isArray(cats) && cats.length ? `&cats=${cats.join(',')}` : '';

// Which bot menu section to narrow to ('auto' / 'construction'). Omitted means
// every section, which is what the pages that predate the split expect.
const groupParam = (group, first = false) =>
    group ? `${first ? '?' : '&'}group=${group}` : '';

export const API = {
    categories: (group) => http.get(API_ENDPOINTS.CATEGORIES + groupParam(group, true)),
    masters: (pagination, cats) => http.get(API_ENDPOINTS.MASTERS + getPagination(pagination) + catsParam(cats)),
    regions: (params) => http.get(API_ENDPOINTS.REGIONS, params),
    services: (params) => http.get(API_ENDPOINTS.SERVICES, params),
    companies: (pagination, cats, group, search) => http.get(API_ENDPOINTS.COMPANIES + getPagination(pagination) + catsParam(cats) + groupParam(group) + (search ? `&q=${encodeURIComponent(search)}` : '')),
    companiesCount: (group) => http.get(API_ENDPOINTS.COMPANIES_COUNT + groupParam(group, true)),
    // Through axios rather than a plain link or antd's own uploader, so the
    // interceptor adds the admin token — the endpoints refuse requests without it
    importTemplate: (group) => http.get(API_ENDPOINTS.COMPANIES_IMPORT_TEMPLATE + groupParam(group, true), {responseType: 'blob'}),
    importListings: (file, group) => {
        const form = new FormData()
        form.append('file', file)
        // Fits the interceptor's 60s timeout: the server geocodes at most 30
        // rows per file, one a second, and asks for coordinates past that
        return http.post(API_ENDPOINTS.COMPANIES_IMPORT + groupParam(group, true), form)
    },
    companyRequests: (pagination, status, group) => http.get(API_ENDPOINTS.COMPANY_REQUESTS + getPagination(pagination) + `&status=${status}` + groupParam(group)),
    companyRequestsCount: (group) => http.get(API_ENDPOINTS.COMPANY_REQUESTS_COUNT + groupParam(group, true)),
    companyApprove: (params) => http.post(API_ENDPOINTS.COMPANY_APPROVE, params),
    companyReject: (params) => http.post(API_ENDPOINTS.COMPANY_REJECT, params),
    masterRequests: (pagination, status) => http.get(API_ENDPOINTS.MASTER_REQUESTS + getPagination(pagination) + `&status=${status}`),
    masterRequestsCount: (params) => http.get(API_ENDPOINTS.MASTER_REQUESTS_COUNT, params),
    masterApprove: (params) => http.post(API_ENDPOINTS.MASTER_APPROVE, params),
    masterReject: (params) => http.post(API_ENDPOINTS.MASTER_REJECT, params),
    botStats: (days) => http.get(API_ENDPOINTS.BOT_STATS + `?days=${days}`),
    webAppStats: (days) => http.get(API_ENDPOINTS.WEBAPP_STATS + `?days=${days}`),
    users: (pagination, search = '') => http.get(API_ENDPOINTS.USERS + getPagination(pagination) + (search ? `&q=${encodeURIComponent(search)}` : '')),
    usersCount: (params) => http.get(API_ENDPOINTS.USERS_COUNT, params),
    activeUsersCount: (params) => http.get(API_ENDPOINTS.ACTIVE_USERS_COUNT, params),
    blockedUsersCount: (params) => http.get(API_ENDPOINTS.BLOCKED_USERS_COUNT, params),
    sos: (pagination) => http.get(API_ENDPOINTS.SOS + getPagination(pagination)),
    sosDelete: (params) => http.post(API_ENDPOINTS.SOS_DELETE, params),
    autoPart: (pagination) => http.get(API_ENDPOINTS.AUTO_PART + getPagination(pagination)),
    autoPartDelete: (params) => http.post(API_ENDPOINTS.AUTO_PART_DELETE, params),
    review: (pagination) => http.get(API_ENDPOINTS.REVIEW + getPagination(pagination)),
    reviewCount: (params) => http.get(API_ENDPOINTS.REVIEW_COUNT, params),
    reviewsSeen: (params) => http.post(API_ENDPOINTS.REVIEW_SEEN, params),
    ads: (pagination) => http.get(API_ENDPOINTS.ADS + getPagination(pagination)),
    adsDelete: (params) => http.post(API_ENDPOINTS.ADS_DELETE, params),

    send: (params) => http.post(API_ENDPOINTS.SEND, params),

    add: (params) => http.post(API_ENDPOINTS.ADD, params),
    addMaster: (params) => http.post(API_ENDPOINTS.ADD_MASTER, params),
    deleteMaster: (params) => http.post(API_ENDPOINTS.DELETE_MASTER, params),
    update: (params) => http.post(API_ENDPOINTS.UPDATE, params),
    delete: (params) => http.post(API_ENDPOINTS.DELETE, params),
    addCategory: (params) => http.post(API_ENDPOINTS.ADD_CATEGORY, params),
    addRegion: (params) => http.post(API_ENDPOINTS.ADD_REGION, params),
    updateRegion: (params) => http.post(API_ENDPOINTS.UPDATE_REGION, params),
    warehouseAccounts: (params) => http.get(API_ENDPOINTS.WAREHOUSE_ACCOUNTS, params),
    warehouseCatalog: (params) => http.get(API_ENDPOINTS.WAREHOUSE_CATALOG, params),
    warehouseCatalogSave: (params, id) =>
        http.post(API_ENDPOINTS.WAREHOUSE_CATALOG + (id ? '/' + id : ''), params),
    warehouseCatalogDelete: (id) => http.delete(API_ENDPOINTS.WAREHOUSE_CATALOG + '/' + id),
    warehouseApprove: (params) => http.post(API_ENDPOINTS.WAREHOUSE_APPROVE, params),
    warehouseReject: (params) => http.post(API_ENDPOINTS.WAREHOUSE_REJECT, params),
    // «Головная компания»: пометить сервис или открыть новую
    warehouseCompany: (id, company) =>
        http.post(API_ENDPOINTS.WAREHOUSE_ACCOUNTS + '/' + id + '/company', { company }),
    warehouseLogin: (id, login) =>
        http.post(API_ENDPOINTS.WAREHOUSE_ACCOUNTS + '/' + id + '/login', { login }),
    warehousePassword: (id, password) =>
        http.post(API_ENDPOINTS.WAREHOUSE_ACCOUNTS + '/' + id + '/password', { password }),
    warehouseAttach: (id, companyId) =>
        http.post(API_ENDPOINTS.WAREHOUSE_ACCOUNTS + '/' + id + '/attach', { companyId }),
    warehouseDetach: (id) =>
        http.post(API_ENDPOINTS.WAREHOUSE_ACCOUNTS + '/' + id + '/detach'),
    warehouseCompanyCreate: (params) =>
        http.post(API_ENDPOINTS.WAREHOUSE_COMPANIES, params),
    warehouseSections: () => http.get(API_ENDPOINTS.WAREHOUSE_SECTIONS),
    warehouseSectionSave: (params, id) =>
        http.post(API_ENDPOINTS.WAREHOUSE_SECTIONS + (id ? '/' + id : ''), params),
    warehouseSectionDelete: (id) =>
        http.delete(API_ENDPOINTS.WAREHOUSE_SECTIONS + '/' + id),
    warehouseAccountItems: (id) =>
        http.get(API_ENDPOINTS.WAREHOUSE_ACCOUNTS + '/' + id + '/items'),
    warehouseTerm: (id, params) =>
        http.post(API_ENDPOINTS.WAREHOUSE_ACCOUNTS + '/' + id + '/term', params),
    warehouseItemSave: (accountId, itemId, params) =>
        http.post(API_ENDPOINTS.WAREHOUSE_ACCOUNTS + '/' + accountId + '/items/' + itemId, params),
    warehouseLink: (id, approve) =>
        http.post(API_ENDPOINTS.WAREHOUSE_ACCOUNTS + '/' + id + '/link', { approve }),
    settings: () => http.get(API_ENDPOINTS.SETTINGS),
    updateSettings: (params) => http.post(API_ENDPOINTS.UPDATE_SETTINGS, params),
    updateCategory: (params) => http.post(API_ENDPOINTS.UPDATE_CATEGORY, params),
    addService: (params) => http.post(API_ENDPOINTS.ADD_SERVICE, params),
    updateService: (params) => http.post(API_ENDPOINTS.UPDATE_SERVICE, params),
    updateMaster: (params) => http.post(API_ENDPOINTS.UPDATE_MASTER, params),

    uploadImage: (params) => http.post(API_ENDPOINTS.UPLOAD_IMAGE, params),
}




